<script lang="ts" setup>
import MainSnackbarQueue from "@/application/components/MainSnackbarQueue.vue";
import MainConfirmation from "@/application/components/MainConfirmation.vue";
</script>

<template>
  <VApp>
    <RouterView />

    <MainSnackbarQueue />
    <MainConfirmation />
  </VApp>
</template>
